import { render, staticRenderFns } from "./_4screen.vue?vue&type=template&id=04153787&"
import script from "./_4screen.vue?vue&type=script&lang=js&"
export * from "./_4screen.vue?vue&type=script&lang=js&"
import style0 from "./_4screen.vue?vue&type=style&index=0&id=04153787&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports